module.exports = __webpack_public_path__ + "manageStatic/img/logo_wapcn.abfc904b.png";